import React from 'react';

export const SiteConfigContext = React.createContext({sitename: 'vrbo'});
